import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { Fonts as i } from "@vds-core/typography";
import { calculateRem as a } from "@vds-core/utilities";
import { ColorTokens as r } from "@vds-tokens/color";
import { LayoutTokens as o } from "@vds-tokens/layout";
import { TypographyTokens as n } from "@vds-tokens/typography";
import l from "styled-components";
import d from "./RadioButtonIcon.js";
var c = a(n.fontsize.body[16].value),
  s = a(n.lineheight.body[20].value),
  p = n.fontweight.bold.value,
  u = a(o.space["1X"].value),
  f = l.label.withConfig({
    displayName: "RadioLabel",
    componentId: "VDS__sc-3lq468-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  ", ";\n"])), s, c, i.VerizonNHGeDS, function (_ref) {
    var e = _ref.$calculateLetterSpacing;
    return null == e ? void 0 : e();
  }, function (_ref2) {
    var e = _ref2.surface;
    return "dark" === e ? r.elements.primary.ondark.value : r.elements.primary.onlight.value;
  }, function (_ref3) {
    var e = _ref3.disabled,
      t = _ref3.surface;
    return e && "\n    color: ".concat("dark" === t ? r.interactive.disabled.ondark.value : r.interactive.disabled.onlight.value, ";\n    cursor: default;\n  ");
  }),
  m = l.div.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-3lq468-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""]))),
  g = l.span.withConfig({
    displayName: "LabelWrapper",
    componentId: "VDS__sc-3lq468-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  margin-bottom: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n"])), u, p, function (_ref4) {
    var e = _ref4.$calculateLetterSpacing;
    return null == e ? void 0 : e();
  }),
  h = "undefined" != typeof navigator && /iPhone|iPad/i.test(navigator.userAgent),
  v = function v(i) {
    var a = i.disabled,
      r = i.surface,
      o = i.children,
      n = i.selected,
      l = i.ariaLabel,
      c = i.label,
      s = i.$radioId,
      p = i.$calculateLetterSpacing;
    return e(f, Object.assign({}, i, {
      disabled: a,
      surface: r,
      $calculateLetterSpacing: p,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      htmlFor: s,
      children: [t(d, {
        selected: n,
        disabled: a,
        surface: r
      }), e(m, {
        role: h && l ? "text" : "",
        id: "label-".concat(s),
        children: [c && t(g, {
          $calculateLetterSpacing: p,
          "aria-hidden": !0,
          children: c
        }), t("div", {
          "aria-hidden": "string" == typeof o,
          children: o
        })]
      })]
    }));
  };
v.defaultProps = {
  disabled: !1,
  surface: "light"
};
export { v as default };